module.exports = __webpack_public_path__ + "98032ff65234a50b907ae7becfa334bd.jpg";